import * as React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import Home from '@/pages/Home'
import { getHomeRedirectToLogin, verifyHomePublicAccessToken, enableHomePublicAccessSession, hasHomePublicAccessSession } from '@/modules/navigation/services/homeSettingsService'

export default function HomeEntry() {
  const [loading, setLoading] = React.useState(true)
  const [toLogin, setToLogin] = React.useState(false)
  const loc = useLocation()

  React.useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const search = loc?.search || ''
        const params = new URLSearchParams(search)
        const access = params.get('access') || params.get('public') || params.get('open')
        const ref = params.get('ref') || params.get('referral')

        // 1) Se veio com token na URL e ele for válido, habilita sessão pública e não redireciona
        if (access && await verifyHomePublicAccessToken(access)) {
          enableHomePublicAccessSession()
          try {
            const url = new URL(window.location.href)
            url.searchParams.delete('access'); url.searchParams.delete('public'); url.searchParams.delete('open'); url.searchParams.delete('ref'); url.searchParams.delete('referral')
            window.history.replaceState(null, '', url.toString())
          } catch {}
          if (!cancelled) { setToLogin(false); return }
        }

        // 1.1) Se veio com ref de afiliado, libera sessão pública nesta aba (comportamento igual ao link exclusivo)
        if (ref && String(ref).trim()) {
          enableHomePublicAccessSession()
          try {
            const url = new URL(window.location.href)
            url.searchParams.delete('ref'); url.searchParams.delete('referral')
            window.history.replaceState(null, '', url.toString())
          } catch {}
          if (!cancelled) { setToLogin(false); return }
        }

        // 2) Se já existe uma sessão pública nesta aba, não redireciona
        if (hasHomePublicAccessSession()) {
          if (!cancelled) { setToLogin(false); return }
        }

        // 3) Caso contrário, aplica a regra canônica
        const flag = await getHomeRedirectToLogin()
        if (!cancelled) setToLogin(!!flag)
      } catch {
        if (!cancelled) setToLogin(false)
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => { cancelled = true }
  }, [loc?.search])

  if (toLogin) {
    return <Navigate to="/login" replace state={{ from: (loc?.pathname || '/') }} />
  }

  return <Home />
}
